import clsx from 'clsx';

export interface FormLoaderProps {
  height?: 'sm' | 'md' | 'lg';
  width?: 'sm' | 'md' | 'lg' | 'xl';
}

export default function FormLoader({ height = 'sm', width = 'xl' }: FormLoaderProps) {
  const styles = clsx(
    'odin-animate-form-loading odin-bg-160 odin-bg-gradient-to-r odin-from-gray-4 odin-via-gray-5 odin-to-gray-4',
    {
      'odin-w-full': width === 'xl',
      'odin-w-3/4': width === 'lg',
      'odin-w-1/2': width === 'md',
      'odin-w-1/4': width === 'sm',
      'odin-h-5 odin-mb-2': height === 'sm',
      'odin-h-8 odin-mb-3': height === 'md',
      'odin-h-10 odin-mb-4': height === 'lg',
    }
  );
  return <div className={styles}></div>;
}
